export enum MediaType {
    Article = 1,
    Video = 2,
}
